export default __webpack_public_path__ + "static/media/1485.c3894c7a.png";